<!----------------------- Компонент вводу пароля користувача --------------------->
<template>
  <smallModal @escape="$emit('close')">
    <div>
      <div class="usr-icon-login-container">
        <div class="user-icon-div">
          <div class="circle-avatar">
            <div data-v-01c4cbed="">
              <div data-v-3b0aa6a6=""><svg data-v-3b0aa6a6="" xmlns="http://www.w3.org/2000/svg" height=""
                  viewBox="0 0 24 24" fill="none" stroke="#00c279" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-user"
                  style="width: 67px;height: 67px;">
                  <path data-v-3b0aa6a6="" stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path data-v-3b0aa6a6="" d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                  <path data-v-3b0aa6a6="" d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                </svg></div>
            </div>
          </div>
        </div>
        <span class="person-login">{{ personLogin }}</span>
      </div>
      <!-- <hr> -->
      <div class="form">
        <div v-if="registered">
          <div class="password">
            <label for="phone">{{ lang['Password'] }}</label>
            <b-form-input type="password" v-model="password" :state="statePass" id="pass" autofocus/>
            <span v-if="password.length > 0" @click="showPass" :class="visiblePass ? 'icon-eye' : 'icon-eye-blocked'"></span>
          </div>
          <div class="forgot-password">
            <span @click="forgotPassword">{{ lang['ForgotYourPassword'] }}?</span>
          </div>
        </div>
        <div v-else>
          <h5 class="notExistH">{{ lang['ThisAccountDoesNotExist'] }}</h5>
        </div>
      </div>
      <hr>
      <div class="buttons" :style="w > 700 && !registered ? { 'max-width': ' 370px' } : { 'width': '' }">
        <button class="btn btn-link cancelButton" @click="cancel">{{ lang['Сancel'] }}</button>
        <button v-if="registered" class="btn enterButton" @click="save">{{ lang['enter'] }}</button>
        <button v-else class="btn btn-success btn-go-reg" @click="goReg">{{ lang['Registration'] }}</button>
      </div>
    </div>
  </smallModal>
</template>

<script>
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна
import { store } from '@/store.js' // Глобальне сховище даних
export default {
  props: ['personLogin', 'registered'],
  components: {
    smallModal
  },
  data() {
    return {
      password: '',
      visiblePass: false,
    }
  },
  mounted() {
    keyevent.$off('enter');
    keyevent.$on('enter', () => {
      if (this.registered) {
        this.statePass ? this.save() : window.say.messageError(this.lang['MinPassLength'])
      } else {
        this.goReg()
      }
    })
  },
  beforeDestroy() {
  keyevent.$off('enter');  // очищуємо перед знищенням компонента
},
  methods: {
    goReg() {
      // Якщо раптом не зареєстрований користувач перейшов на авторизацію під номером телефону або поштою яких немає
      // базі, пропонуємо йому реєструватися, паралельно записуючи введений ним логін
      const mailRegular = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
      if (mailRegular.test(this.personLogin) == true) {
        this.$emit('close');
        keyevent.$off('enter')
        this.$router.push('/registration?email=' + this.personLogin);
      } else {
        this.$emit('close');
        keyevent.$off('enter')
        this.$router.push('/registration?phone=' + this.personLogin);
      }
    },
    // Якщо користувач забув пароль, то направляємо його на капчу
    forgotPassword() {
      try {
        this.$emit('goToCaptch');
        this.$emit('close');
      } catch (err) {
        // console.log(err)
      }
    },
    cancel() {
      keyevent.$off('enter');
      this.$emit('close')
    },
    // Беремо паролі при натисканні на кнопку та відправляємо його в батька, там викликаємо функцію логіна
    save() {
      if (this.statePass) {
        this.$emit('sendPass', this.password);
        // this.$emit('close')
      } else {
        window.say.messageError(this.lang['MinPassLength']);
      }
    },
    showPass() {
      this.visiblePass = !this.visiblePass
      const input = document.getElementById('pass');
      if (input.getAttribute('type') == 'password') {
        input.setAttribute('type', 'text');
      } else {
        input.setAttribute('type', 'password');
      }
    },
  },
  computed: {
    statePass() {
      return this.password.length >= 4 ? true : false;
    },
    // Мова додатку
    lang() {
      return window.lang;
    },
    w() {
      return store.window.width;
    }
  }
}
</script>

<style scoped>
.btn {
  width: 49%;
}

.btn-success {
  border: none;
}

/* .form {
  margin-bottom: 30px;
} */

.buttons {
  display: flex;
  justify-content: space-between;
}

.forgot-password {
  text-align: right;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}

.form-control.is-valid {
  background-image: none;
  border-color: #00C279;
}

.usr-icon-login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 20px;
}

.account-icon {
  height: 3rem;
}

.user-icon-div {
  /* border: 1px solid gray; */
  /* width: 4rem;
  height: 4rem; */
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 999px;
  margin-bottom: 1rem;
}

.circle-avatar {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 5px solid #00c279;
}

.person-login[data-v-01c4cbed] {
  color: #696969;
}

.notExistH {
  color: grey;
  text-align: center;
}

.person-login {
  font-size: 1.3rem;
  font-weight: 500;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

label {
  /* font-family: 'Montserrat'; */
}

.icon-eye,
.icon-eye-blocked {
  position: absolute;
  right: 12.5%;
  top: 61.5%;
}

.btn-go-reg {
  text-transform: uppercase;
  font-size: 10pt;
  background-color: #00C279;
}

.cancelButton {
  /* text-align:left; */
  text-transform: uppercase;
  font-size: 10pt;
  color: gray
}

.enterButton {
  text-transform: uppercase;
  font-size: 10pt;
  background-color: #00C279;
  color: white;
}

@media screen and (max-width: 700px) {
  .btn-go-reg {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.password {
  position: relative;
}

input[type="password"]::-ms-reveal {
  display: none;
}

.form-control.is-valid, .form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid, .form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}
</style>